import RatingApi from '../interfaces/api';

const ratingApiTest: RatingApi = {
  sendRating: async () => {},
};

export default ratingApiTest;
